/**
 * Guest Guard - Redirect authenticated users
 * Prevents authenticated users from accessing guest-only pages (like login)
 */

import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { KeycloakAuthService } from '../services/auth/keycloak.service';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {
  private keycloakService = inject(KeycloakAuthService);
  private router = inject(Router);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    if (typeof window === 'undefined') {
      return true;
    }

    try {
      const isAuthenticated = await this.keycloakService.isLoggedIn();

      if (isAuthenticated) {
        return this.router.createUrlTree(['/panel/dashboard']);
      }

      return true;
    } catch (error) {
      return true;
    }
  }
}
